The preference for remuneration (including salary or hourly rate, benefits, etc.) for a position in a given country.

This is only available for Apply with SEEK candidate profiles.
For candidate applications, uploaded candidate profiles & purchased profiles this will be an empty list.
